import type { LucideIcon } from "lucide-react";
import { ChevronRight } from "lucide-react";
import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/ui/link";
import { cn } from "@/lib/utils";

type MenuCardProps = {
  href: string;
  title: string;
  description: string;
  icon?: LucideIcon;
  highlight?: boolean;
  className?: string;
};

/**
 * The one menu-card style for section index pages (Settings, Admin, Compliance):
 * icon in its own column, title + description in the next, and a chevron on the
 * right marking the drill-down. Descriptions clamp to two lines so a long one
 * can't blow up the row height — see DESIGN.md › Components.
 */
export function MenuCard({
  href,
  title,
  description,
  icon: Icon,
  highlight,
  className,
}: MenuCardProps) {
  return (
    <Link to={href}>
      <Card
        className={cn("cursor-pointer card-hover h-full", highlight && "border-primary", className)}
      >
        <CardHeader>
          <div className="flex items-start gap-3">
            {Icon && <Icon className="h-6 w-6 text-muted-foreground shrink-0 mt-0.5" />}
            <div className="min-w-0 flex-1">
              <CardTitle>{title}</CardTitle>
              <CardDescription className="mt-1 line-clamp-2">{description}</CardDescription>
            </div>
            <ChevronRight className="h-5 w-5 text-muted-foreground shrink-0 self-center" />
          </div>
        </CardHeader>
      </Card>
    </Link>
  );
}
